import React from "react";
import moment from "moment";
import { Button } from "@material-ui/core";

import FileDetails from "./FileDetails";

import ConfirmButton from "../../../common/components/ConfirmButton";
import { numberWithSpaces } from "../../../utilities/formaters";

export const LoadedFilesList = ({
  data,
  finalizeFile,
  loadDetails,
  removeLoanFromFile,
}) => {
  function getCsv(id, type, date) {
    let url = "/api/admin/debt-agency/get-request-file-content?Id=" + id;
    let token = JSON.parse(localStorage.getItem("admin.usr"))["access_token"];

    fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
      },
    }).then((resp) => {
      if (resp.status >= 400 && resp.status < 600) {
        alert("Couldn't download file.");
        return "Error";
      } else {
        resp.json().then((data) => {
          let csvContent = "data:text/csv;charset=utf-8," + data;
          var encodedUri = encodeURI(csvContent);
          var link = document.createElement("a");
          link.setAttribute("href", encodedUri);
          link.setAttribute(
            "download",
            "Csv-for-" + type + ":" + date + ".csv",
          );
          document.body.appendChild(link);

          link.click();
        });
      }
    });
  }

  return (
    <React.Fragment>
      <h2>Loaded Files</h2>
      {data.map((file) => {
        return (
          <div key={file.Id} className="loaded-file table-wrapper">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <div className="loaded-file-row">Id: {file.Id}</div>
                <div className="loaded-file-row">
                  Created: {moment(file.Created).format("YYYY-MM-DD HH:mm:ss")}
                </div>
                <div className="loaded-file-row">Type: {file.Type}</div>
                <div className="loaded-file-row">
                  Number Of Loans: {file.NumberOfLoans}
                </div>
                <div className="loaded-file-row">
                  Amount Due: {numberWithSpaces(file.AmountDue.Amount)} SEK
                </div>
                <div className="loaded-file-row">
                  Finalized: <strong>{file.Finalized ? "Yes" : "No"}</strong>
                </div>
              </div>
              <div>
                {file.Finalized ? (
                  <Button
                    variant="outlined"
                    onClick={() =>
                      getCsv(
                        file.Id,
                        file.Type,
                        moment(file.Created).format("YYYY-MM-DD HH:mm:ss"),
                      )
                    }
                  >
                    Get Csv
                  </Button>
                ) : (
                  <ConfirmButton
                    label="Finalize File"
                    action={() => {
                      finalizeFile(file.Id);
                    }}
                  />
                )}
              </div>
            </div>
            <FileDetails {...{ file, loadDetails, removeLoanFromFile }} />
          </div>
        );
      })}
    </React.Fragment>
  );
};
